import { render, staticRenderFns } from "./PurchaseRequest.vue?vue&type=template&id=3b08d0e6&"
import script from "./PurchaseRequest.vue?vue&type=script&lang=ts&"
export * from "./PurchaseRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports